<template>
  <v-card tile flat>
    <div class="pa-2">
      <base-button @click="onOpenSelectStyle()">Sao chép</base-button>
      <base-button
        @click="addStyle(defaultStyleAdd)"
        v-if="!showAdd"
        text
        class="text-none"
      >
        <v-icon>mdi-plus</v-icon>
        {{ $t('preview.actions.add') }}
      </base-button>
    </div>

    <v-tabs
      v-model="currentItem"
      v-if="curent && curent.length > 0"
      class="flex-grow-1"
    >
      <v-tab
        v-for="(item, i) in curent"
        :key="i"
        @click.prevent="selectTab(item)"
        height="30px"
      >
        {{ 'Rule #' + (item + 1) }}
        <v-btn icon depressed text @click.prevent="removeStyle($event, item)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentItem" v-if="!showAdd">
      <v-tab-item v-for="item in curent" :key="item">
        <edit-rule
          :item.sync="data[item]"
          :typeLayer.sync="data[item].type"
          v-if="data[item]"
          :fields="fields"
        ></edit-rule>
      </v-tab-item>
    </v-tabs-items>
    <div v-else>
      <v-btn
        @click="addStyle(item)"
        v-for="item of items"
        :key="item"
        class="ma-2 text-none"
        tile
        color="primary"
        >{{ $t('preview.addStyle', { name: item }) }}</v-btn
      >
    </div>
    <StyleSelectDialog ref="StyleSelectDialog" @submit="onCopySelectStyle" />
  </v-card>
</template>

<script>
import StyleSelectDialog from '../style-select-dialog.vue'
import { DEFAULT_VALUE_STYLE } from './constant'
import EditRule from './edit-rule.vue'
export default {
  components: { EditRule, StyleSelectDialog },
  props: {
    value: {},
    fields: { type: Array },
    defaultStyleAdd: { type: String, default: 'Polygon' },
  },
  data: () => ({
    data: [],
    items: ['Point', 'Polygon', 'Line'],
    showAdd: true,
    curent: [],
    more: [],
    currentItem: 0,
    menu: false,
  }),
  watch: {
    value: {
      handler(value) {
        if (value) {
          this.data = value || []
          if (this.data.length > 0) {
            this.setInit(this.data.length)
          } else {
            this.showAdd = true
          }
        } else {
          this.showAdd = true
        }
      },
      immediate: true,
    },
  },
  methods: {
    onOpenSelectStyle() {
      this.$refs.StyleSelectDialog.open()
    },
    onCopySelectStyle(style) {
      this.$emit('input', style.content)
    },
    setInit(length) {
      let res = [...Array(this.data.length)].map((x, index) => index)
      this.curent = res
      if (length > 0) {
        this.showAdd = false
      } else {
        this.showAdd = true
      }
    },
    addStyle(type) {
      this.data.push({
        type,
        comment: { title: '' },
        style: DEFAULT_VALUE_STYLE[type] || {},
        rules: [],
      })
      this.setInit(this.data.length)
      this.currentItem = this.data.length - 1
    },
    removeStyle(e, index) {
      e.stopPropagation()
      this.data.splice(index, 1)
      this.setInit(this.data.length)
      this.menu = false
    },
    selectTab(index) {
      this.showAdd = false
    },
  },
}
</script>
